
export class PoOperationCompletionModel {
    operationCategory: string;
    operationCode: string;
    operationName: string;
    operationOrder: number;
    
    inTransitQty: number;
    todayInputQty: number;
    todayOutputQty: number;
    totalInputQty: number;
    totalOutPutQty: number;  // total scan qty till date
    hitRatePerDay: number;   // the total completed out operation scans from the beginning / no of days spent till now
    hitRatePerHour: number;   // the total completed out operation scans for this current day / no of days spent till now
    thisMonthInput: number;  // the total qty for this current month
    thisMonthOutput: number;
    
    opWipTillNow: number;

    lastInputScanDateTime: string; // the timestamp at which the first time the operation is scanned
    firstInputScanDateTime: string; // the timestamp at which the last time the operation is scanned

    constructor(operationCategory: string, operationCode: string, operationName: string, operationOrder: number, todayInputQty: number, todayOutputQty: number, totalInputQty: number, totalOutPutQty: number, hitRatePerDay: number, hitRatePerHour: number,thisMonthInput: number, thisMonthOutput: number, lastInputScanDateTime: string,firstInputScanDateTime: string, inTransitQty: number, opWipTillNow?: number) {
        this.operationCategory = operationCategory;
        this.operationCode = operationCode;
        this.operationName = operationName;
        this.operationOrder = operationOrder;
        this.totalInputQty = totalInputQty;
        this.totalOutPutQty = totalOutPutQty;
        this.todayInputQty = todayInputQty;
        this.todayOutputQty = todayOutputQty;
        this.hitRatePerDay = hitRatePerDay;
        this.hitRatePerHour = hitRatePerHour;
        this.thisMonthInput = thisMonthInput;
        this.thisMonthOutput = thisMonthOutput;
        this.lastInputScanDateTime = lastInputScanDateTime;
        this.firstInputScanDateTime = firstInputScanDateTime;
        this.inTransitQty = inTransitQty;
        this.opWipTillNow = opWipTillNow;
    }
}